import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as translationService from '../services/translationService'
import * as routeService from '../services/routeService'

import FormStepper from 'components/FormStepper'
import { Button, ButtonGroup, TextContainer, PropertyBar, ErrorText } from './../components'
import FinancialScene from './scenes/FinancialScene'
import { getCurrentStepType } from '../services/stepService'
import { fetchApi } from '../services/networkService'
import { PHASE_INFORMATION_SUCCESS } from '../actions/FlowAction'
import { getIsFirstPhase, getShouldIncludeIncomeStatement } from '../selectors/flowSelector'
import { scroller } from 'react-scroll'
import ConfirmModal from '../components/ConfirmModal/ConfirmModal'

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { user = {} } = AuthReducer
  const { step, property, application } = FlowReducer
  return {
    user,
    step,
    property,
    application,
    isFirstPhase: getIsFirstPhase(FlowReducer),
    shouldIncludeIncomeStatement: getShouldIncludeIncomeStatement(FlowReducer),
  }
}

const mapDispatchToProps = dispatch => ({
  updatePhaseInformation: (completedAt, step) => {
    dispatch({
      type: PHASE_INFORMATION_SUCCESS,
      completedAt,
      step,
    })
  },
})

class FinancialView extends React.Component {
  static propTypes = {
    user: PropTypes.any,
    step: PropTypes.any,
    property: PropTypes.any,
    id: PropTypes.any,
    updatePhaseInformation: PropTypes.any,
    isFirstPhase: PropTypes.bool,
    shouldIncludeIncomeStatement: PropTypes.bool,
  }

  state = {
    mainError: null,
    currentItem: null,
    isSubmitting: false,
    touched: false,
    confirmModalIsOpen: false,
    confirmAccepted: false,
  }

  financialRef = {}

  componentDidMount = () => {
    scroller.scrollTo('mainContent', {
      smooth: true,
    })
  }

  goToPreviousFlow = () => {
    this.financialRef
      .onSubmit(false)
      .then(() => {
        routeService.goToNextFlowPage(this.props.step, -1)
      })
      .catch(() => {})
  }

  goToNextFlow = async () => {
    const { confirmAccepted } = this.state
    const { step, application } = this.props
    const isFirstPhase = getCurrentStepType(step) === 'VISIT_REQUEST_STEPS'

    try {
      this.setState({ isSubmitting: true })

      if (this.props.isFirstPhase && this.props.shouldIncludeIncomeStatement) {
        if (application.incomeStatement !== 'INTAKE_INCOME_STATEMENT_REFUSE') {
          await this.financialRef.onSubmit()
        }

        if (application.incomeStatement === 'INTAKE_INCOME_STATEMENT_REFUSE' && !confirmAccepted) {
          this.setState({
            confirmModalIsOpen: true,
            isSubmitting: false,
          })

          return
        }
      } else {
        await this.financialRef.onSubmit()
      }

      if (isFirstPhase) {
        try {
          const now = new Date()
          await fetchApi(`/users/${this.props.user.id}/application/sendToBroker/${this.props.property.id}`, {}, 'post')
          routeService.goToThankyouPage()
          this.props.updatePhaseInformation(now.toISOString(), this.props.step)
        } catch (err) {
          console.log(err)
          const {
            response: {
              data: { error },
            },
          } = err
          this.setState({ touched: true, isSubmitting: false })
          if (error && error.code === 'EMAIL_NOT_VERIFIED') {
            this.setState({
              mainError: translationService.t('system.error.EMAIL_NOT_VERIFIED'),
            })
          } else {
            this.setState({
              mainError: translationService.t('system.500.server.error'),
            })
          }
        }
      } else {
        routeService.goToNextFlowPage(this.props.step)
      }
    } catch (errors) {
      console.warn('CATCH: ', errors)
      console.warn(errors)
      this.setState({
        touched: true,
        isSubmitting: false,
      })
    }
  }

  handleConfirm = () => {
    this.setState(
      {
        confirmAccepted: true,
        confirmModalIsOpen: false,
      },
      this.goToNextFlow,
    )
  }
  handleCancel = () => {
    this.setState({
      confirmModalIsOpen: false,
    })
  }

  render() {
    const { mainError } = this.state
    const { property, step } = this.props
    const isFirstPhase = getCurrentStepType(step) === 'VISIT_REQUEST_STEPS'

    return (
      <div>
        {property && <PropertyBar property={property} />}
        <FormStepper steps={routeService.getStepperRoutes(this.props.step, property.zip)} />
        <TextContainer>
          {mainError && (
            <div>
              <ErrorText>{mainError}</ErrorText>
              <br />
            </div>
          )}
          <FinancialScene onRef={ref => (this.financialRef = ref)} />
          <div>
            <ButtonGroup>
              <Button onClick={this.goToPreviousFlow}>{translationService.buttonPrevious()}</Button>
              <Button onClick={() => this.goToNextFlow()} primary loading={this.state.isSubmitting}>
                {isFirstPhase ? translationService.overviewSendAction(step) : translationService.buttonNext()}
              </Button>
            </ButtonGroup>
          </div>
        </TextContainer>
        <ConfirmModal
          isOpen={this.state.confirmModalIsOpen}
          onConfirm={this.handleConfirm}
          onCancel={this.handleCancel}
          message={translationService.financialIncomeStatementRefuseConfirm()}
          confirmAction={translationService.yes()}
        />
      </div>
    )
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FinancialView)



// WEBPACK FOOTER //
// ./src/views/FinancialView.js